export const rateTypes = ['nvArea', 'scatteredTreesCount', 'gsmArea', 'ggfArea', 'mflArea', 'sbbArea', 'srfArea']
